/**
 * Безопасно извлекает сообщение об ошибке из axios-ошибки.
 * Обрабатывает сетевые ошибки (нет response), нестандартные форматы и т.д.
 */
export function getErrorMessage(error, fallback) {
  if (!fallback) fallback = 'Произошла ошибка, попробуйте позже'
  if (!error) return fallback
  if (error.response && error.response.data) {
    return error.response.data.message || error.response.data.error || fallback
  }
  if (error.message) return error.message
  return fallback
}
